import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { Header } from '@components';
import { StyledContainer, StyledContainerWrapper, StyledMain, StyledPrivateWrapper } from './private-layout.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PrivateLayout = function PrivateLayout(_ref) {
  var inline = _ref.inline;
  return /*#__PURE__*/_jsx(StyledPrivateWrapper, {
    children: /*#__PURE__*/_jsxs(Box, {
      flex: 1,
      overflow: "auto",
      children: [/*#__PURE__*/_jsx(Header, {}), /*#__PURE__*/_jsx(StyledMain, {
        component: "main",
        children: /*#__PURE__*/_jsx(StyledContainerWrapper, {
          children: inline ? /*#__PURE__*/_jsx(Outlet, {}) : /*#__PURE__*/_jsx(StyledContainer, {
            fixed: true,
            children: /*#__PURE__*/_jsx(Outlet, {})
          })
        })
      })]
    })
  });
};

export { PrivateLayout };